document.addEventListener('DOMContentLoaded', event => {    
    let hasAddedSealUnitChoice = false;
    let hasAddedDiameterChoice = false;
    let hasAddedDiameterUnitChoice = false;
    // '' = nothing selected yet, so no sealing range shows until the user picks one.
    // Values: 'in' | 'mm' | 'NPT' | 'SAE' | 'M'
    let chosen_seal_unit = '';
    let chosen_diameter = 'ID';
    let chosen_diameterunit = 'in';
    var cts_app = document.querySelectorAll('html')[0]._x_dataStack[0];
    const mobile = window.matchMedia("(max-width: 768px)");

    // PO Number / Cart Attributes support
    window.updateCartAttribute = async function(name, value) {
        if (!cts_app) return;
        cts_app.cart_loading = true;
        try {
            const response = await fetch(
                `${window.Shopify.routes.root}cart/update.js`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { [name]: value } })
                }
            );
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.description || 'Failed to update cart attribute');
            }
        } catch (error) {
            console.error('Error updating cart attribute:', error);
        } finally {
            cts_app.cart_loading = false;
        }
    };

    // Refresh cart on pageshow (back / forward) fix for Edge and Mobile
    window.addEventListener('pageshow', (e) => {
        // Edge and mobile
        if (cts_app && !mobile.matches) {
            cts_app.updateCart(false);            
        }
    });
       
    document.addEventListener('Searchanise.Loaded', function(event, input, container) {
        
        (function ($) {         
            /* Replaces description with specs meta value if specs exists */
            $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
                // console.log('datarequestend',data);
                data.items.forEach((d)=>d.description = d.metafield_890876f17d8f280fff23283fe46f6524?.split('|').join('<br>') || d.description);
            });        

            $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
                cts_app.updateCart(true);
            });            
            
            let seal_range_filter_in, seal_range_filter_mm, has_seal_range_filter;

            let id_seal_in, id_seal_mm, has_id, od_seal_in, od_seal_mm, has_od;

            let thread_NPT, thread_SAE, thread_M, has_thread;

            let body_style;

            let surface_facet, surface_facet_mobile, surface_facet_mobile2;

            // Medical metafield facet (metafield_d16712d1e90071023e9de9456c3fbbbe).
            // When "Medical" is checked, Threaded sealing-range units
            // (NPT/SAE/Metric) are not valid and are hidden from the list.
            let medical_facet, medical_facet_mobile, medical_facet_mobile2;

            // Which surface option is currently checked in the native facet10
            // filter: 'Smooth' | 'Threaded' | '' (none). Determines which
            // Sealing Range Unit options are offered.
            let active_surface = '';

            // Remembers whether the shopper has opened the Sealing Range Unit
            // list, so re-renders don't force it back closed. Starts closed so
            // it's collapsed on page load.
            let sealUnitOpen = false;

            // didClearPersistedFilters and isApplyingFilters are declared at
            // the DOMContentLoaded scope so they persist across any number of
            // Searchanise.Loaded re-fires.

            // Show/hide all three DOM variants of one facet group
            // (desktop, mobile header, mobile body) in a single call.
            // Each facet block — seal_range_filter_in, thread_NPT, etc. —
            // has exactly these three variants, so this collapses the
            // repetitive triple-toggle pattern below.
            function toggleGroup(group, show) {
                const v = show ? 'block' : 'none';
                group?.[0]?.style.setProperty('display', v, 'important');
                group?.[1]?.style.setProperty('display', v, 'important');
                group?.[2]?.style.setProperty('display', v, 'important');
            }

            // The five Sealing Range Unit options and which surface each belongs to.
            const SEAL_UNIT_OPTIONS = [
                { value: 'in',  label: 'Inches',      surface: 'Smooth'   },
                { value: 'mm',  label: 'Millimeters', surface: 'Smooth'   },
                { value: 'NPT', label: 'NPT',         surface: 'Threaded' },
                { value: 'SAE', label: 'SAE',         surface: 'Threaded' },
                { value: 'M',   label: 'Metric',      surface: 'Threaded' }
            ];

            // The control's heading depends on which option types are offered
            // (see effectiveSurface):
            //   both Smooth + Threaded -> "Connection Details"
            //   Smooth only            -> "Sealing Range Unit"
            //   Threaded only          -> "Thread Type"
            function sealUnitTitleFor(surface) {
                if (surface === 'Smooth')   return 'Sealing Range Unit';
                if (surface === 'Threaded') return 'Thread Type';
                return 'Connection Details';
            }

            // Read the native facet10 (Surface Type) filter to see which option
            // is checked. Re-queries the DOM each call so it never depends on a
            // stale cached element after Searchanise re-renders. The checkbox
            // `value` attribute is a clean "Smooth"/"Threaded" (confirmed live).
            // Returns 'Smooth' or 'Threaded' when exactly one is checked; returns
            // '' when neither OR both are checked — in both those cases every
            // Sealing Range Unit option should be shown.
            function readActiveSurface() {
                const facets = [
                    document.querySelector('#snize_filters_block_snize_facet10'),
                    document.querySelector('#snize_product_filter_header_snize_facet10'),
                    document.querySelector('#snize_product_filter_snize_facet10')
                ].filter(Boolean);
                let smooth = false, threaded = false;
                for (const facet of facets) {
                    facet.querySelectorAll('input:checked').forEach(inp => {
                        const v = (inp.value || '').trim();
                        if (/threaded/i.test(v)) threaded = true;
                        else if (/smooth/i.test(v)) smooth = true;
                    });
                }
                // Both (or neither) checked => no single active surface => show all.
                if (smooth && threaded) return '';
                if (threaded) return 'Threaded';
                if (smooth)   return 'Smooth';
                return '';
            }

            // Read the native Medical metafield facet to see whether "Medical"
            // is checked. Re-queries the DOM each call for the same re-render
            // safety reasons as readActiveSurface.
            function readIsMedical() {
                const facets = [medical_facet, medical_facet_mobile, medical_facet_mobile2].filter(Boolean);
                for (const facet of facets) {
                    const checked = facet.querySelector('input:checked');
                    if (checked) {
                        const v = (checked.value || '').trim();
                        if (/medical/i.test(v)) return true;
                    }
                }
                return false;
            }

            // Which surface types actually exist among the products on the
            // current page. Searchanise only renders a facet when at least one
            // result has a value for it, so the presence of the in/mm seal-range
            // facets means Smooth products are on the page, and the presence of
            // the NPT/SAE/Metric facets means Threaded products are. Facets we
            // hide with display:none are still in the DOM, so they still count.
            // Re-queries the DOM each call (re-render safe).
            const SMOOTH_FACET_IDS = [
                'snize_filters_block_filter_metafield_5ca16f433209745ce003384917821ad9',
                'snize_filters_block_filter_metafield_7f9152f33fb92b8018fa5176778cd10b',
                'snize_product_filter_header_filter_metafield_5ca16f433209745ce003384917821ad9',
                'snize_product_filter_header_filter_metafield_7f9152f33fb92b8018fa5176778cd10b',
                'snize_product_filter_filter_metafield_5ca16f433209745ce003384917821ad9',
                'snize_product_filter_filter_metafield_7f9152f33fb92b8018fa5176778cd10b'
            ];
            const THREADED_FACET_IDS = [
                'snize_filters_block_snize_facet9', 'snize_product_filter_header_snize_facet9', 'snize_product_filter_snize_facet9',
                'snize_filters_block_snize_facet6', 'snize_product_filter_header_snize_facet6', 'snize_product_filter_snize_facet6',
                'snize_filters_block_snize_facet8', 'snize_product_filter_header_snize_facet8', 'snize_product_filter_snize_facet8'
            ];
            function readAvailableSurfaces() {
                const exists = (ids) => ids.some(id => document.getElementById(id));
                let smooth   = exists(SMOOTH_FACET_IDS);
                let threaded = exists(THREADED_FACET_IDS);
                // Can't tell (e.g. mid re-render) => don't restrict anything.
                if (!smooth && !threaded) { smooth = true; threaded = true; }
                return { smooth, threaded };
            }

            // Is a given seal-unit option allowed right now? Combines:
            //   - what's on the page (only Smooth products => only in/mm, etc.)
            //   - the shopper's Surface Type pick (facet10)
            //   - the Medical rule (Medical => no Threaded units)
            function isSealUnitAllowed(surfaceOf, ctx) {
                if (surfaceOf === 'Smooth'   && !ctx.available.smooth)   return false;
                if (surfaceOf === 'Threaded' && !ctx.available.threaded) return false;
                if (ctx.activeSurface && surfaceOf !== ctx.activeSurface) return false;
                if (ctx.isMedical && surfaceOf === 'Threaded') return false;
                return true;
            }

            function sealUnitContext() {
                return {
                    available: readAvailableSurfaces(),
                    activeSurface: readActiveSurface(),
                    isMedical: readIsMedical()
                };
            }

            // The heading follows whichever option types are actually offered:
            // only Smooth units => "Sealing Range Unit", only Threaded units =>
            // "Thread Type", both => "Connection Details".
            function effectiveSurface(ctx) {
                const smoothOk   = isSealUnitAllowed('Smooth', ctx);
                const threadedOk = isSealUnitAllowed('Threaded', ctx);
                if (smoothOk && !threadedOk) return 'Smooth';
                if (threadedOk && !smoothOk) return 'Threaded';
                return '';
            }

            // Update the heading text of every rendered seal-unit control to
            // match the active surface.
            function applySealUnitTitle(surface) {
                const title = sealUnitTitleFor(surface);
                document.querySelectorAll('[id^="cts_seal_unit_title_"]').forEach(el => {
                    // Only write when the text actually changes. Writing textContent
                    // unconditionally would mutate a node inside the observed sidebar
                    // subtree, re-triggering the MutationObserver -> refresh ->
                    // write -> observer ... loop that can make the page never settle.
                    if (el.textContent !== title) el.textContent = title;
                });
            }

            // Show only the Sealing Range Unit options allowed by the active
            // surface. Smooth -> in/mm; Threaded -> NPT/SAE/M; none -> all.
            // When Medical is selected, Threaded units are excluded regardless
            // of the surface filter.
            let _refreshingSealUnits = false;
            // Holder for the sidebar MutationObserver + its targets, so that
            // refreshSealUnitOptions can disconnect it while it mutates our own
            // nodes (title text, checkbox state, facet display) and reconnect
            // after — otherwise those writes re-trigger the observer, creating a
            // never-settling loop that can make the page appear to hang.
            let _sealUnitObserver = null;
            let _sealUnitObserveTargets = [];
            const _observeOpts = { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked', 'aria-checked'] };
            function refreshSealUnitOptions() {
                if (_refreshingSealUnits) return; // guard against observer re-entry
                _refreshingSealUnits = true;
                if (_sealUnitObserver) _sealUnitObserver.disconnect();
                try {
                    const ctx = sealUnitContext();
                    active_surface = ctx.activeSurface;
                    document.querySelectorAll('.cts-seal-unit-option').forEach(optEl => {
                        const surfaceOf = optEl.getAttribute('data-surface');
                        const allowed = isSealUnitAllowed(surfaceOf, ctx);
                        optEl.style.setProperty('display', allowed ? '' : 'none', 'important');
                        // If the currently chosen unit is no longer allowed, clear it.
                        if (!allowed && optEl.querySelector('input')?.value === chosen_seal_unit) {
                            chosen_seal_unit = '';
                        }
                    });
                    // Re-sync checkbox checked states to chosen_seal_unit.
                    document.querySelectorAll('.cts-seal-unit-checkbox').forEach(cb => {
                        cb.checked = (cb.value === chosen_seal_unit);
                    });
                    // Keep the heading in sync with the options actually offered
                    // (page contents + surface pick + Medical).
                    applySealUnitTitle(effectiveSurface(ctx));
                    // Re-hide seal-range/thread facets: a surface pick (e.g.
                    // Threaded) re-renders and would otherwise re-show them before
                    // a specific unit is chosen.
                    applySealRangeFacetVisibility();
                } finally {
                    _refreshingSealUnits = false;
                    // Reconnect the observer now that our own mutations are done.
                    if (_sealUnitObserver && _sealUnitObserveTargets.length) {
                        _sealUnitObserveTargets.forEach(t => _sealUnitObserver.observe(t, _observeOpts));
                    }
                }
            }

            // Apply seal-range/thread facet visibility based on the currently
            // chosen unit. Nothing selected => every seal-range facet hidden.
            // Kept separate so it can be re-applied after Searchanise re-renders
            // (which otherwise repaint and re-show the facets).
            function applySealRangeFacetVisibility() {
                const groups = [
                    ['in',  [seal_range_filter_in, seal_range_filter_in_mobile, seal_range_filter_in_mobile2]],
                    ['mm',  [seal_range_filter_mm, seal_range_filter_mm_mobile, seal_range_filter_mm_mobile2]],
                    ['NPT', [thread_NPT, thread_NPT_mobile, thread_NPT_mobile2]],
                    ['SAE', [thread_SAE, thread_SAE_mobile, thread_SAE_mobile2]],
                    ['M',   [thread_M,   thread_M_mobile,   thread_M_mobile2]]
                ];
                groups.forEach(([val, grp]) => toggleGroup(grp, chosen_seal_unit === val));
            }

            function showSealUnitSelection(e) {
                if (e && e.target) {
                    // Checkbox behaves as single-select: picking one clears the rest;
                    // unchecking the active one clears the selection.
                    chosen_seal_unit = e.target.checked ? e.target.value : '';
                }

                // Keep every unit checkbox in sync (single-select behaviour).
                document.querySelectorAll('.cts-seal-unit-checkbox').forEach(cb => {
                    cb.checked = (cb.value === chosen_seal_unit);
                });

                // Nothing selected ('') => all seal-range facets hidden.
                applySealRangeFacetVisibility();

                // If a unit is chosen, constrain the native surface facet to the
                // matching surface only (Smooth for in/mm, Threaded for NPT/SAE/M);
                // when nothing is chosen, show both surface options again.
                const chosenSurface = SEAL_UNIT_OPTIONS.find(o => o.value === chosen_seal_unit)?.surface || '';
                filterSurfaceOptions(chosenSurface);
            }

            // Narrow the native facet10 Surface filter's visible options. Pass
            // 'Smooth' or 'Threaded' to show only that option; '' to show both.
            function filterSurfaceOptions(surface) {
                const facets = [surface_facet, surface_facet_mobile, surface_facet_mobile2].filter(Boolean);
                facets.forEach(facet => {
                    // Each option is typically an <li> containing the label text.
                    facet.querySelectorAll('li, .snize-item, .snize-filter-option').forEach(item => {
                        const txt = (item.textContent || '').trim();
                        const isSmooth   = /smooth/i.test(txt);
                        const isThreaded = /threaded/i.test(txt);
                        if (!isSmooth && !isThreaded) return; // not an option row
                        const keep = !surface ||
                            (surface === 'Smooth' && isSmooth) ||
                            (surface === 'Threaded' && isThreaded);
                        item.style.setProperty('display', keep ? '' : 'none', 'important');
                    });
                });
            }

            function updateDiameterDisplay() {
                const diameterSelects = document.querySelectorAll('.sg_select_diameter');
                const unitSelects     = document.querySelectorAll('.sg_select_diameterunit');

                const pickActive = (list) =>
                    [...list].find(sel => sel.offsetParent !== null) || list[0];

                chosen_diameter     = pickActive(diameterSelects)?.value || chosen_diameter;
                chosen_diameterunit = pickActive(unitSelects)?.value     || chosen_diameterunit;

                diameterSelects.forEach(sel => { if (sel.value !== chosen_diameter)     sel.value = chosen_diameter; });
                unitSelects.forEach(sel     => { if (sel.value !== chosen_diameterunit) sel.value = chosen_diameterunit; });

                // Four ID/OD × in/mm combinations, each with desktop +
                // mobile (header) + mobile2 (body) variants.
                const combos = [
                    ['ID', 'in', [id_seal_in, id_seal_in_mobile, id_seal_in_mobile2]],
                    ['ID', 'mm', [id_seal_mm, id_seal_mm_mobile, id_seal_mm_mobile2]],
                    ['OD', 'in', [od_seal_in, od_seal_in_mobile, od_seal_in_mobile2]],
                    ['OD', 'mm', [od_seal_mm, od_seal_mm_mobile, od_seal_mm_mobile2]]
                ];
                combos.forEach(([d, u, grp]) =>
                    toggleGroup(grp, chosen_diameter === d && chosen_diameterunit === u));
            }

            function showDiameterSelection(e) { updateDiameterDisplay(); }
            function showDiameterUnitSelection(e) { updateDiameterDisplay(); }


            // Fires after the Search Results widget (incl. filters sidebar) finishes rendering
            $(document).on('Searchanise.ResultsUpdated', function (event, $container) {

                seal_range_filter_in = document.querySelector('#snize_filters_block_filter_metafield_5ca16f433209745ce003384917821ad9');                
                seal_range_filter_mm = document.querySelector('#snize_filters_block_filter_metafield_7f9152f33fb92b8018fa5176778cd10b');
                seal_range_filter_in_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_5ca16f433209745ce003384917821ad9');                
                seal_range_filter_mm_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_7f9152f33fb92b8018fa5176778cd10b');
                seal_range_filter_in_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_5ca16f433209745ce003384917821ad9');                
                seal_range_filter_mm_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_7f9152f33fb92b8018fa5176778cd10b');

                id_seal_in = document.querySelector('#snize_filters_block_snize_facet4');
                id_seal_mm = document.querySelector('#snize_filters_block_snize_facet3');
                id_seal_in_mobile = document.querySelector('#snize_product_filter_header_snize_facet4');
                id_seal_mm_mobile = document.querySelector('#snize_product_filter_header_snize_facet3');
                od_seal_in = document.querySelector('#snize_filters_block_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                od_seal_mm = document.querySelector('#snize_filters_block_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');
                od_seal_in_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                od_seal_mm_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');
                id_seal_in_mobile2 = document.querySelector('#snize_product_filter_snize_facet4');
                id_seal_mm_mobile2 = document.querySelector('#snize_product_filter_snize_facet3');
                od_seal_in_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                od_seal_mm_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');

                has_seal_range_filter = seal_range_filter_in && seal_range_filter_mm;
                has_seal_range_filter_mobile = seal_range_filter_in_mobile && seal_range_filter_mm_mobile;

                has_id_od = id_seal_in && id_seal_mm && od_seal_in && od_seal_mm;
                has_id_od_mobile = id_seal_in_mobile && id_seal_mm_mobile && od_seal_in_mobile && od_seal_mm_mobile;
                has_od = od_seal_in && od_seal_mm;
                has_od_mobile = od_seal_in_mobile && od_seal_mm_mobile;

                thread_NPT = document.querySelector('#snize_filters_block_snize_facet9');
                thread_NPT_mobile = document.querySelector('#snize_product_filter_header_snize_facet9');
                thread_NPT_mobile2 = document.querySelector('#snize_product_filter_snize_facet9');
                thread_SAE = document.querySelector('#snize_filters_block_snize_facet6');
                thread_SAE_mobile = document.querySelector('#snize_product_filter_header_snize_facet6');
                thread_SAE_mobile2 = document.querySelector('#snize_product_filter_snize_facet6');
                thread_M = document.querySelector('#snize_filters_block_snize_facet8');
                thread_M_mobile = document.querySelector('#snize_product_filter_header_snize_facet8');
                thread_M_mobile2 = document.querySelector('#snize_product_filter_snize_facet8');

                body_style = document.querySelector('#snize_filters_block_snize_facet5');
                body_style_mobile = document.querySelector('#snize_product_filter_header_snize_facet5');

                // facet10 = Surface Type metafield (Smooth / Threaded), rendered
                // natively by Searchanise. We READ from it (which option is checked)
                // and REACT to it — we don't build our own surface control.
                surface_facet = document.querySelector('#snize_filters_block_snize_facet10');
                surface_facet_mobile = document.querySelector('#snize_product_filter_header_snize_facet10');
                surface_facet_mobile2 = document.querySelector('#snize_product_filter_snize_facet10');

                // Medical metafield facet — read from it the same way as Surface
                // Type to decide whether Threaded seal units should be offered.
                medical_facet = document.querySelector('#snize_filters_block_filter_metafield_d16712d1e90071023e9de9456c3fbbbe');
                medical_facet_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_d16712d1e90071023e9de9456c3fbbbe');
                medical_facet_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_d16712d1e90071023e9de9456c3fbbbe');

                has_thread = thread_NPT || thread_SAE || thread_M;
                has_thread_mobile = thread_NPT_mobile || thread_SAE_mobile || thread_M_mobile;

                has_thread_and_range = has_thread && has_seal_range_filter;
                has_thread_and_range_mobile = has_thread_mobile && has_seal_range_filter_mobile;

                if ((has_seal_range_filter || has_seal_range_filter_mobile || has_thread || has_thread_mobile)) {
                    const filterSidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');
                    const mobileModalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');

                    const addSealUnitSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-seal-unit-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.id = `cts_seal_unit_block_${idSuffix}`;
                        const titleId = `cts_seal_unit_title_${idSuffix}`;
                        // Match the native facet block wrapper attributes so the
                        // theme's CSS (title alignment, +/- icon) applies identically.
                        wrapper.setAttribute('role', 'group');
                        wrapper.setAttribute('aria-labelledby', titleId);
                        wrapper.style.display = 'block';

                        // Clone the EXACT native Searchanise facet structure and
                        // classes so the theme's own CSS styles it identically to
                        // the Surface Type facet (custom checkbox via
                        // .snize-filter-checkbox + .needsclick spans). data-surface
                        // on each <li> drives the surface-based show/hide.
                        const rows = SEAL_UNIT_OPTIONS.map(o => `
                            <li class="cts-seal-unit-option" data-surface="${o.surface}">
                                <label>
                                    <div class="snize-filter-checkbox">
                                        <input class="snize-product-filters-checkbox cts-seal-unit-checkbox"
                                               type="checkbox"
                                               name="cts_seal_unit_${idSuffix}"
                                               value="${o.value}"
                                               ${chosen_seal_unit === o.value ? 'checked' : ''}>
                                        <span class="needsclick"></span>
                                    </div>
                                    <span class="needsclick">${o.label}</span>
                                </label>
                            </li>`).join('');

                        // Title mirrors the native expandable header. Honors the
                        // remembered open state (collapsed on first page load).
                        // The heading text is dynamic (see sealUnitTitleFor): it
                        // is "Connection Details" when both Smooth and Threaded
                        // products are on the page, otherwise "Sealing Range Unit"
                        // or "Thread Type" to match what's available.
                        wrapper.innerHTML = `
                            <div class="snize-product-filters-title cts-seal-unit-selector"
                                 role="button" tabindex="0" aria-expanded="${sealUnitOpen}"
                                 aria-labelledby="${titleId}">
                                <span class="cts-seal-unit-toggle-icon">${sealUnitOpen ? '\u2212' : '+'}</span>
                                <span id="${titleId}" aria-hidden="true">${sealUnitTitleFor(effectiveSurface(sealUnitContext()))}</span>
                            </div>
                            <ul class="snize-product-filters-list cts-seal-unit-options"
                                style="display:${sealUnitOpen ? 'block' : 'none'};">
                                ${rows}
                            </ul>`;

                        // Native title toggles the list open/closed; replicate it
                        // and remember the state so re-renders keep it. We render
                        // our own +/- icon directly instead of relying on snize's
                        // sprite-based .snize-product-filters-open/-close icons,
                        // which don't render correctly in this context.
                        const titleEl = wrapper.querySelector('.cts-seal-unit-selector');
                        const listEl  = wrapper.querySelector('.cts-seal-unit-options');
                        const iconEl  = wrapper.querySelector('.cts-seal-unit-toggle-icon');
                        const applyIcons = () => {
                            if (iconEl) iconEl.textContent = sealUnitOpen ? '\u2212' : '+';
                        };
                        applyIcons();
                        const toggleOpen = () => {
                            sealUnitOpen = listEl.style.display === 'none';
                            listEl.style.display = sealUnitOpen ? 'block' : 'none';
                            titleEl.setAttribute('aria-expanded', String(sealUnitOpen));
                            applyIcons();
                        };
                        titleEl.addEventListener('click', toggleOpen);
                        titleEl.addEventListener('keydown', (ev) => {
                            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); toggleOpen(); }
                        });

                        wrapper.querySelectorAll('.cts-seal-unit-checkbox').forEach(cb => {
                            cb.addEventListener('change', showSealUnitSelection);
                        });
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedSealUnitChoice = true;
                    };

                    // Positioning reference: prefer the in/mm seal-range facets;
                    // when Threaded is active those are gone, so fall back to a
                    // thread facet (or the surface facet). null => appended at end.
                    const desktopRef = seal_range_filter_in || seal_range_filter_mm ||
                                       thread_NPT || thread_SAE || thread_M ||
                                       surface_facet || null;
                    const mobileRef  = seal_range_filter_in_mobile || seal_range_filter_mm_mobile ||
                                       thread_NPT_mobile || thread_SAE_mobile || thread_M_mobile ||
                                       surface_facet_mobile || null;

                    addSealUnitSelector(filterSidebar, 'desktop', desktopRef);
                    addSealUnitSelector(mobileModalContent, 'mobile', mobileRef);

                    // React to changes in the native facet10 Surface filter. Searchanise
                    // frequently re-renders facet DOM on interaction, which wipes direct
                    // listeners — so we use a delegated document listener (survives
                    // re-renders) plus a MutationObserver watching the filter containers.
                    if (!window.__ctsSurfaceReactivityBound) {
                        const surfaceIds = [
                            'snize_filters_block_snize_facet10',
                            'snize_product_filter_header_snize_facet10',
                            'snize_product_filter_snize_facet10',
                            // Medical metafield facet — same reactivity treatment as
                            // Surface Type, since it also constrains seal unit options.
                            'snize_filters_block_filter_metafield_d16712d1e90071023e9de9456c3fbbbe',
                            'snize_product_filter_header_filter_metafield_d16712d1e90071023e9de9456c3fbbbe',
                            'snize_product_filter_filter_metafield_d16712d1e90071023e9de9456c3fbbbe'
                        ];
                        const isInsideSurfaceFacet = (node) =>
                            surfaceIds.some(id => node?.closest?.('#' + id));

                        // Delegated change/click: any interaction inside the surface
                        // or medical facet re-evaluates the unit options (deferred so
                        // Searchanise finishes updating checked state first).
                        document.addEventListener('change', (ev) => {
                            if (isInsideSurfaceFacet(ev.target)) setTimeout(refreshSealUnitOptions, 0);
                        }, true);
                        document.addEventListener('click', (ev) => {
                            if (isInsideSurfaceFacet(ev.target)) setTimeout(refreshSealUnitOptions, 0);
                        }, true);

                        // "Reset filters" clears everything native — also clear our
                        // Sealing Range Unit selection so it doesn't linger.
                        document.addEventListener('click', (ev) => {
                            if (ev.target?.closest?.('.snize-product-filters-reset-all, .snize-clear-all-button')) {
                                chosen_seal_unit = '';
                                // Uncheck our checkboxes and restore full option list.
                                document.querySelectorAll('.cts-seal-unit-checkbox').forEach(cb => { cb.checked = false; });
                                // Let Searchanise finish its own reset/re-render first,
                                // then re-sync visibility (all seal-range facets hidden,
                                // both surface options restored, options unfiltered).
                                setTimeout(() => {
                                    showSealUnitSelection();
                                    refreshSealUnitOptions();
                                }, 0);
                            }
                        }, true);

                        // Observe re-renders of the filter sidebars and re-sync.
                        const observeTargets = [
                            document.querySelector('.snize-filters-sidebar.snize-product-filters'),
                            document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content')
                        ].filter(Boolean);
                        if (observeTargets.length) {
                            _sealUnitObserveTargets = observeTargets;
                            _sealUnitObserver = new MutationObserver(() => {
                                // Re-resolve surface facet elements (they may be new nodes),
                                // then refresh option visibility.
                                surface_facet         = document.querySelector('#snize_filters_block_snize_facet10');
                                surface_facet_mobile  = document.querySelector('#snize_product_filter_header_snize_facet10');
                                surface_facet_mobile2 = document.querySelector('#snize_product_filter_snize_facet10');
                                medical_facet         = document.querySelector('#snize_filters_block_filter_metafield_d16712d1e90071023e9de9456c3fbbbe');
                                medical_facet_mobile   = document.querySelector('#snize_product_filter_header_filter_metafield_d16712d1e90071023e9de9456c3fbbbe');
                                medical_facet_mobile2  = document.querySelector('#snize_product_filter_filter_metafield_d16712d1e90071023e9de9456c3fbbbe');
                                refreshSealUnitOptions();
                            });
                            _sealUnitObserveTargets.forEach(t => _sealUnitObserver.observe(t, _observeOpts));
                        }
                        window.__ctsSurfaceReactivityBound = true;
                    }

                    // Initial paint: constrain options to any pre-checked surface,
                    // sync checkbox state, and apply seal-range visibility.
                    // Default chosen_seal_unit is '' => no sealing range shows.
                    refreshSealUnitOptions();
                    showSealUnitSelection();
                }

                if (has_id_od || has_id_od_mobile) {
                    const filterSidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');
                    const mobileModalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');

                    const addDiameterSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-diameter-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-diameter-selector">
                                <label for="sg_select_diameter_${idSuffix}" class="cts-diameter-selector-label">Select ID or OD Surface:</label>
                                <select name="sg_select_diameter" id="sg_select_diameter_${idSuffix}" class="sg_select_diameter">
                                    <option value="ID" ${chosen_diameter == 'ID' ? 'selected' : ''}>Inside Diameter</option>
                                    <option value="OD" ${chosen_diameter == 'OD' ? 'selected' : ''}>Outside Diameter</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showDiameterSelection;
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedDiameterChoice = true;
                    };

                    const addDiameterUnitSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-diameterunit-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-diameterunit-selector">
                                <label for="sg_select_diameterunit_${idSuffix}" class="cts-diameterunit-selector-label">Select a Sealing Range Unit:</label>
                                <select name="sg_select_diameterunit" id="sg_select_diameterunit_${idSuffix}" class="sg_select_diameterunit">
                                    <option value="in" ${chosen_diameterunit == 'in' ? 'selected' : ''}>Inches</option>
                                    <option value="mm" ${chosen_diameterunit == 'mm' ? 'selected' : ''}>Millimeters</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showDiameterUnitSelection;
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedDiameterUnitChoice = true;
                    };

                    addDiameterSelector(filterSidebar, 'desktop', id_seal_in);
                    addDiameterSelector(mobileModalContent, 'mobile', id_seal_in_mobile);
                    addDiameterUnitSelector(filterSidebar, 'desktop', id_seal_in);
                    addDiameterUnitSelector(mobileModalContent, 'mobile', id_seal_in_mobile);

                    // Sync all selects to their chosen values, then dispatch on the visible one (or fall back to the first)
                    for (const [cls, value] of [['sg_select_diameter', chosen_diameter], ['sg_select_diameterunit', chosen_diameterunit]]) {
                        const selects = document.querySelectorAll(`.${cls}`);
                        selects.forEach(sel => sel.value = value);
                        const active = [...selects].find(sel => sel.offsetParent !== null) || selects[0];
                        if (active?.value) active.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                
                // The standalone Thread selector has been merged into the single
                // "Select Sealing Range Unit" dropdown (NPT / SAE / Metric options),
                // so it is no longer built separately here.

                // The Surface selector has been removed.

            });
        })(window.Searchanise.$);
    });
});
var app = (document.querySelectorAll('html')[0] || {})._x_dataStack
  ? document.querySelectorAll('html')[0]._x_dataStack[0]
  : undefined;
  

/* ============================================================
   Anchor scroll fix (v6 — yields to user scroll)
   Lands the linked section near the top, keeps correcting only
   until the user scrolls themselves, then stops immediately.
   Put at the VERY TOP of assets/theme_edits.js.
   ============================================================ */
(function () {
  try {
    var h = window.location.hash;
    var id = (h && h.length > 1) ? decodeURIComponent(h.slice(1)) : null;
    if (!id) { return; }

    var HEADER_OFFSET = 150; // reveal this much above the section
    var userInterrupted = false;

    function targetTop() {
      var el = document.getElementById(id);
      if (!el) return null;
      return el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    }

    function align() {
      if (userInterrupted) return;
      var top = targetTop();
      if (top === null) return;
      if (Math.abs(window.pageYOffset - top) > 2) {
        window.scrollTo({ top: top, behavior: 'auto' });
      }
    }

    // Any real user scroll input stops the auto-correction for good.
    function stop() { userInterrupted = true; }
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchmove', stop, { passive: true });
    window.addEventListener('keydown', function (e) {
      // arrows, page up/down, space, home/end
      if ([32,33,34,35,36,38,40].indexOf(e.keyCode) !== -1) stop();
    });

    var start = Date.now();
    function loop() {
      if (userInterrupted) return;
      align();
      if (Date.now() - start < 4500) requestAnimationFrame(loop);
    }

    function run() { align(); loop(); }

    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run);
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 50); });
  } catch (e) {
    console.log('[scroll-fix] ERROR', e);
  }
})();